<template>
	<div class="avatar-field">
        <div class="rounded-circle circle-cropped avatar-xl mr-3 bg-white">
            <img v-if="original_preview" :src="default_url" class="img-fluid">
            <template v-else>
                <!-- Image File -->
                <img v-if="imageSelected" :src="url" class="img-fluid">

                <!-- Everything else -->
                <div v-else class="text-center text-white bg-gray-400 leading-none pt-2" style="height:100%">
                    <i class="far fa-eye-slash text-2xl pb-1"></i>
                    <div class="font-weight-bold">Not an image!</div>
                </div>
            </template>
        </div>
		<div class="filezone mt-2 align-center mx-auto"> 
			<input type="file"  id="files" ref="files" @change="onFileChange" />
			<p>{{ button ? button : 'change' }}</p>
		</div>
	</div>
</template>

<script>
	export default {
        props: ['default_url', 'button'],
		
		data () {
			return {
                original_preview: this.default_url,
				url: this.default_url,
                file: null,
                imageSelected: true,
			}
		},

		methods: {
		    onFileChange(e) {
                this.original_preview = null;
                
                if (e.target.files[0].type.startsWith('image/')) {
                    this.imageSelected = true;
                    this.file = e.target.files[0];
                    this.url = URL.createObjectURL(this.file);
                    this.$emit('avatar_changed', this.url );
                }
                else {
                    this.nonImageSelected();
                }
		    },

            nonImageSelected() {
                this.imageSelected = false;
                this.file = null;
            }
		}
	}	

</script>

<style scoped>
    input[type="file"]{
        opacity: 0;
        width: 100%;
        height: 100%;
        position: absolute;
        cursor: pointer;
    }
    .filezone {
        display: inline-block;
        outline: 1px dotted #cacccd;
        outline-offset: -5px;
        background: #f0f3f5;
        color: #23282c;
        position: relative;
        cursor: pointer;
        transition:.2s all ease-out;
    }
    .filezone:hover {
        background: #2f353a;
        color:#fff;
        transition:.15s all ease-in-out;
    }

    .filezone p {
        width:80px;
        font-size: .75rem;
        text-align: center;
        padding: 6px 12px;
        margin-bottom: 0px;
    }

/*#preview { position:relative; }
#preview img {
  max-width: 200px;
  max-height: 400px;
}

#preview span.btn { position:absolute; top:-5px; right:-5px; }  */

</style>